import React, { ReactElement } from 'react';

import Icon from 'atomic/icon/icon';

const ReviewListError: React.FC = (): ReactElement => (
    <div className="review-list__blank">
        <Icon icon="no-comment" className="review-list__blank-icon" />
        <div className="review-list__blank-header">
            Coś poszło nie tak
        </div>
        <p className="review-list__blank-text">
            Nie udało się pobrać opinii. Spróbuj ponownie później.
        </p>
    </div>
);

export default ReviewListError;
